import { VerificationItemEventResponse } from 'types/api-responses';
import { Comment, Accepted, Rejected, Undo } from 'components/icons';
import { Date } from 'components/date';
import {
  VerificationCorrectContent,
  VerificationIncorrectContent,
  VerificationRevertedContent,
  VerificationEventPayload,
} from 'components/event-renderer/verification-event-content';

import style from './verification-event.module.scss';

const VerificationEvent = ({
  item,
}: {
  item: VerificationItemEventResponse;
}) => {
  let Icon: React.FunctionComponent<{ className: string }>;
  const kind = item.kind;
  if (kind === 'create_comment') {
    Icon = Comment;
  } else if (kind === 'verification_correct') {
    Icon = Accepted;
  } else if (kind === 'verification_incorrect') {
    Icon = Rejected;
  } else if (kind === 'verification_reverted') {
    Icon = Undo;
  } else {
    Icon = Comment;
  }
  return (
    <li className={style.event}>
      <div className={style.header}>
        <Icon className={style.icon} />
        <div>
          <h6>{item.createdBy}</h6>
          <Date
            className={style.date}
            date={item.createdAt}
            format={'lll'}
            showTime
          />
        </div>
      </div>

      <div className={style.content}>
        <VerificationEventContent item={item} />
      </div>
    </li>
  );
};

function VerificationEventContent({
  item,
}: {
  item: VerificationItemEventResponse;
}) {
  const payload = item.payload as VerificationEventPayload;

  if (item.kind === 'verification_incorrect') {
    return <VerificationIncorrectContent payload={payload} />;
  }

  if (item.kind === 'verification_correct') {
    return <VerificationCorrectContent payload={payload} />;
  }

  if (item.kind === 'verification_reverted') {
    return <VerificationRevertedContent payload={payload} />;
  }

  if (item.kind === 'create_comment' && item.payload.content) {
    return (
      <div>
        {Array.isArray(item.payload.content) ? (
          item.payload.content.map((content, index) => (
            <p key={index}>{content}</p>
          ))
        ) : (
          <p>{item.payload.content}</p>
        )}
      </div>
    );
  }

  return null;
}

export { VerificationEvent };
